<script>
import {FormWizard, TabContent} from "vue-form-wizard";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Ký số",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: { PageHeader},
  data() {
    return {
      title: "Ký số",
      items: [
        {
          text: "Trang chủ",
          href: "/",
        },
        {
          text: "Thông tin ký số",
          active: true,
        }
      ],
      getKySiIframe: "https://signdigital.dthu.edu.vn/",
      // getKySiIframe: "https://localhost:5003/",
     //  getKySiIframe: "https://localhost:44323/",
      files: null,
      apiUrl: process.env.VUE_APP_API_URL,
      url: `${process.env.VUE_APP_API_URL}files/upload`,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 1,
        maxFilesize: 30,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".jpeg,.jpg,.png,.gif,.doc,.docx,.xlsx,.pptx,.pdf",
      },
      showModal: false,
    };
  },
  created() {
    this.loadKySoLocalStoage();
  },
  methods: {
    loadKySoLocalStoage(){
      let dataJSON = localStorage.getItem("kysophaply");
      if(dataJSON){
        let convertData = JSON.parse(dataJSON);
        if(convertData){
          this.getKySiIframe += "?userName=" + convertData.userName + "&password=" + convertData.password + "&fileName=" + convertData.fileName + "&path=" + convertData.path + "&vanBanDiId=" + convertData.vanBanDiId;
        }
      }
    },
    removeThisFile(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.files.filter(x => {
          return x.fileId != idFile;
        })
        this.files = resultData;
      }
    },
    addThisFile(file, response) {
      if (this.files == null || this.files.length <= 0) {
        this.files = [];
      }
      let fileSuccess = response.data;
      this.files.push({
        fileId: fileSuccess.id,
        fileName: fileSuccess.fileName,
        ext: fileSuccess.ext,
        size: fileSuccess.size,
      })
    },
    onComplete() {
      this.showModal = true;
    },
  }
}
</script>
<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <iframe style="height: 80vh; width: 100%" :src="getKySiIframe"></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.td-stt {
  text-align: center;
  width: 50px;
}

.td-xuly {
  text-align: center;
  width: 130px;
}

.table > tbody > tr > td {
  padding: 0px;
  line-height: 30px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

.divider:before {
  content: "";
  display: block;
  position: absolute;
  height: 2px;
  width: 150px;
  background-color: #00568c;
}
</style>
